type AvailabilityDayRowProps = {
  dayLabel: string;
  available: boolean;
  startTime: string;
  endTime: string;
  onChange: (patch: { available: boolean; startTime: string; endTime: string }) => void;
};

export function AvailabilityDayRow({
  dayLabel,
  available,
  startTime,
  endTime,
  onChange,
}: AvailabilityDayRowProps) {
  return (
    <div className="staff-avail-row">
      <div className="staff-avail-row__day">
        <label className="staff-avail-row__toggle">
          <input
            type="checkbox"
            checked={available}
            onChange={(e) => onChange({ available: e.target.checked, startTime, endTime })}
          />
          <span>{dayLabel}</span>
        </label>
      </div>
      {available ? (
        <div className="staff-avail-row__times">
          <input
            type="time"
            value={startTime}
            aria-label={`${dayLabel} start`}
            onChange={(e) => onChange({ available, startTime: e.target.value, endTime })}
          />
          <span className="muted">to</span>
          <input
            type="time"
            value={endTime}
            aria-label={`${dayLabel} end`}
            onChange={(e) => onChange({ available, startTime, endTime: e.target.value })}
          />
        </div>
      ) : (
        <p className="staff-avail-row__off muted">Unavailable</p>
      )}
    </div>
  );
}
